import React from 'react';
import {
    Card,
    FormLayout,
} from '@shopify/polaris';
import {
    TagTemplateFormElement
} from '../formElements/FormElements';

export function TagOrdersByVendorSettings(props) {

    function onValueTemplateChange(value) {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tagTemplate = value;
        props.onSettingsChange(newSettings);
    }

    return (
        <React.Fragment>
            <Card.Section title="Tag Settings">
                <FormLayout>
                    <TagTemplateFormElement
                        templateSettings={props.settings.tagTemplate}
                        templateSettingsErrors={props.settingsErrors["valueTemplate"] || {}}
                        onChange={onValueTemplateChange}
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}